module.exports = __webpack_public_path__ + "img/bg5.591917ff.png";